import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface RegionStoreState {
  region: string;
  setRegion: (rg: string) => void;
}

export const useRegionStore = create<RegionStoreState>()(
  persist(
    devtools((set) => ({
      region: 'KIC',
      setRegion: (rg: string) => {
        const newRg = rg;
        set({ region: newRg });
      },
    })),
    { name: 'region-store' }
  )
);
